<template>
  <div class="content ht-100v pd-0">
    <div class="content-body pd-10">
      <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
        <div>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb breadcrumb-style1 mg-b-10">
              <li class="breadcrumb-item">
                <router-link to="/account/">Support</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">Customer Support</li>
            </ol>
          </nav>
          <h4 class="mg-b-0 tx-spacing--1">Customer Support</h4>
        </div>
        <div class="d-none d-md-block">

          <button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5">
            <router-link class="tx-white" to="/account/account-activities">
              <BIconCardChecklist />
              View Activities
            </router-link>
          </button>
          <b-button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5">
            <router-link class="tx-white" to="/account/account-statement">
              <BIconCompass />
              Statements
            </router-link>
          </b-button>

        </div>
      </div>
      <div class="col-md-7">
        <CustomerSupportForm />

      </div>
    </div>
  </div>
</template>

<script>
import CustomerSupportForm from "@/components/form/CustomerSupportForm";
export default {
name: "CustomerSupport",
  components: {CustomerSupportForm}
}
</script>

<style scoped>

</style>
